/* eslint-disable max-len */
import React from 'react';


const BookmarkIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 8 10"
      width="8"
      height="10">
      <path
        fill="#393F45"
        fillRule="evenodd"
        d="M1,0 L7,0 C7.55228475,-1.01453063e-16 8,0.44771525 8,1 L8,10 L4,8.01714939 L0,
        10 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z" id="path-1" />
    </svg>
  );
};

const FlagIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 10 11"
      width="10"
      height="11">
      <path
        fill="#393F45"
        fillRule="evenodd"
        d="M2.00009169,8.11093672 L2.00009169,10.0887325 C2.00009169,10.4246985 1.68234883,
        11 1.00008531,11 C0.317821801,11 0,10.4591046 0,10.1231386 L7.89394515e-05,
        1.01386709 C7.89394515e-05,0.453923758 0.447797044,0 1.00008531,0 L10,
        0 L8.00007709,4.05546836 L10,8.11093672 L2.00009169,8.11093672 Z" id="path-1" />
    </svg>
  );
};

const ReadingIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 10 9"
      width="10"
      height="9">
      <path
        fill="#393F45"
        fillRule="evenodd"
        d="M0,0 L5,2.03541475 L10,0 L10,6.45135105 L10,
        6.45135105 C10,6.85803537 9.75370907,7.22421247 9.37703914,7.37754838 L5.75407828,
        8.85239397 L5.75407828,8.85239397 C5.27062121,9.0492011 4.72937879,
        9.0492011 4.24592172,8.85239397 L0.62296086,7.37754838 L0.62296086,
        7.37754838 C0.24629093,7.22421247 -7.55492981e-16,6.85803537 -4.4408921e-16,6.45135105 L0,0 Z" id="path-1" />
    </svg>
  );
};

const UploadingIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="10"
      height="14"
      viewBox="0 0 20 24">
      <path
        fill="#383434"
        fillRule="evenodd"
        d="M13 20v-8.586l3.413 3.414c.32.32.896.262,
        1.286-.129.39-.39.448-.966.129-1.286L12.62,
        8.207a.747.747 0 0 0-.604-.204.747.747 0 0,
        0-.604.204l-5.206 5.206c-.32.32-.262.896.128 1.286s.966.448,
        1.286.129L11 11.448V20H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-6z" id="path-1" />
    </svg>
  );
};

const AllBooksIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 20 20"
      width="9"
      height="24">
      <g fill="#383434">
        <rect width="4" height="13" x="4" y="7" rx="1" />
        <rect width="4" height="17" x="10" y="3" rx="1" />
        <rect width="4" height="17" x="15" y="3" rx="1" transform="rotate(-15 17 11.5)" />
      </g>
    </svg>
  );
};

const LockedBooksIcon = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 15 20"
      width="12"
      height="16">
      <g fill="none" fillRule="evenodd">
        <path fill="#383434" d="M4 7h8a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z" />
        <path stroke="#383434" strokeWidth="1.5" d="M5 5a3 3 0 1 1 6 0v4" />
      </g>
    </svg>
  );
};

const CloudIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 13 8"
      width="13"
      height="8">
      <path
        fill="#393F45"
        fillRule="evenodd"
        d="M10.7764103,3.64914042 C10.7641026,3.64914042 10.7538462,3.65215209 10.7415385,
        3.65215209 C10.5579487,1.60923579 8.82564103,0 6.69025641,0 C4.81846154,
        0 3.25846154,1.23880035 2.77435897,2.91830845 C2.71692308,2.91529678 2.6625641,
        2.9022462 2.60410256,2.9022462 C1.16512821,2.9022462 0,4.04366922 0,
        5.4511231 C0,6.85857699 1.16512821,8 2.60410256,8 L10.7764103,8 C12.0041026,8 13,7.02522274 13
        ,5.82457021 C13,4.62291379 12.0041026,3.64914042 10.7764103,3.64914042" id="path-1" />
    </svg>
  );
};

const ArrowIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="24px"
      height="18px"
      viewBox="0 0 24 18">
      <path fill="#be5b04" fillRule="evenodd" d="M3.91276049,9.99233835 L23.0121598,9.99233835 C23.5607549,9.99233835 24.0059976,9.54859648 24.0078499,9.00000445 C24.0078536,8.99889136 24.0078555,8.99777827 24.0078555,8.99666517 C24.0078555,8.45045852 23.5650675,8.00767055 23.0188609,8.00767055 L23.0188609,8.00767055 L3.91275199,8.00767055 L10.1818415,1.73858103 C10.5794159,1.34100661 10.5794159,0.696411126 10.1818415,0.298836712 C9.78409264,-0.0989121556 9.13936351,-0.0993954334 8.7410188,0.297756696 L8.7410188,0.297756696 L0.964618298,8.05087586 L-0.00337265081,8.98403159 L0.0126439058,9.00000019 L-0.00337196316,9.01596811 L0.964577427,9.94908377 L8.74101811,17.702243 C9.13936282,18.0993951 9.78409195,18.0989119 10.1818408,17.701163 L10.1818408,17.701163 C10.5794152,17.3035886 10.5794152,16.6589931 10.1818408,16.2614187 L10.1818408,16.2614187 L3.91276049,9.99233835 Z" id="path-1" />
    </svg>
  );
};

const AudioIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="16"
      height="14">
      <g fill="#383434" fillRule="evenodd">
        <path d="M2.426 7.573l1.28-.293a1 1 0 0 1 1.223.975v4.56a1 1 0 0 1-1.181.983l-1.301-.24A2.99 2.99 0 0 1 0 10.618a3.123 3.123 0 0 1 2.426-3.045z" />
        <path fillRule="nonzero" d="M3.005 7v1.944H1.3V7C1.3 2.262 4.48.119 7.997.119c3.519 0 6.72 2.298 6.72 6.881v1.944H13.03V7c0-3.237-2.11-5.186-5.033-5.186C5.074 1.814 3.005 3.62 3.005 7z" />
        <path d="M12.29 7.245l1.258.257A3.066 3.066 0 0 1 16 10.505a3.11 3.11 0 0 1-2.445 3.039l-1.25.274a1 1 0 0 1-1.214-.977V8.225a1 1 0 0 1 1.2-.98z" />
      </g>
    </svg>
  );
};

export { BookmarkIcon, FlagIcon, ReadingIcon, CloudIcon, ArrowIcon, AudioIcon, UploadingIcon, AllBooksIcon, LockedBooksIcon };
